import tw from "twin.macro";

export const coloredIcon = IconBase => tw(IconBase)`text-primary-500`